import UserAvatar from '../components/UserAvatar';

export function buildUserOptions(users, avatarSize = 22) {
  return [
    { value: '', label: 'Unassigned' },
    ...(users || []).map((u) => ({ value: u.uid, label: u.displayName, icon: <UserAvatar user={u} size={avatarSize} showStatus={false} /> })),
  ];
}

export function findAssignee(users, assigneeId) {
  return users?.find((u) => u.uid === assigneeId);
}
